import { clearTenantSessionStorage } from '../utils/storage';

export const SESSION_REJECTED_EVENT = 'aiker-session-rejected';

// A response belongs to the bearer sent with that request, not a later login.
export function handleSessionRejection(status, requestToken) {
  if (status !== 401 || !requestToken || localStorage.getItem('authToken') !== requestToken) return false;
  // PartnerLogin owns the in-progress exchange and its full-page navigation.
  if (/^\/partner-login\/?$/i.test(window.location.pathname)) return false;
  localStorage.removeItem('authToken');
  localStorage.removeItem('userRole');
  clearTenantSessionStorage();
  if (localStorage.getItem('admin_auth_token') === requestToken) {
    localStorage.removeItem('admin_auth_token');
    localStorage.removeItem('admin_auth_role');
    localStorage.removeItem('admin_auth_session_expires_at');
  }
  window.dispatchEvent(new Event(SESSION_REJECTED_EVENT));
  if (window.location.pathname !== '/login') window.location.replace('/login?reason=session-invalid');
  return true;
}

export function sessionResponseError(response, requestToken, message) {
  handleSessionRejection(response.status, requestToken);
  const error = new Error(message);
  error.status = response.status;
  return error;
}

export function rejectAxiosSession(error) {
  const headers = error?.config?.headers;
  const authorization = headers?.get?.('Authorization') || headers?.Authorization || headers?.authorization;
  const requestToken = typeof authorization === 'string' ? /^Bearer (.+)$/i.exec(authorization)?.[1] : null;
  handleSessionRejection(error?.response?.status, requestToken);
  return Promise.reject(error);
}
